import { AuthenticationProvider } from 'graphql-ts-types';

import { getAuthenticationProvider } from '../../edit-profile-form/components/LinkedAccounts/utils';
import type { ThirdPartySignUpData } from '../types';

export const getAuthenticationSource = (
  isThirdPartySignUpFlow: boolean,
  thirdPartySignUpData?: Pick<ThirdPartySignUpData, 'provider' | 'providerToken'>
) =>
  isThirdPartySignUpFlow
    ? getAuthenticationProvider(thirdPartySignUpData.provider)
    : AuthenticationProvider.Home24Password;
